import React from 'react';

import { Box, Inline, Stack } from '@atlaskit/primitives';
import { cssMap } from '@atlaskit/css';

import type { AIEventsInstrumentationConfig } from '@atlassian/ai-analytics';
import { AIEventsInstrumentationProvider } from '@atlassian/ai-analytics';

import { useAudioBriefing } from '../../../hooks/useAudioBriefing';
import { PlayPauseButton } from '../../controls/PlayPauseButton';
import { SkipBackButton } from '../../controls/SkipBackButton';
import { SkipForwardButton } from '../../controls/SkipForwardButton';
import { AudioTimeIndicator } from '../../controls/AudioTimeIndicator';
const aiAnalyticsConfig: AIEventsInstrumentationConfig = {
	product: 'confluence',
	subproduct: 'confluence',
	source: 'page',
	aiFeatureName: 'aiAudioBriefing',
	proactiveGeneratedAI: 0,
	userGeneratedAI: 1,
};

type AudioBriefingPopupListenPanelProps = {
	audioRef: React.RefObject<HTMLAudioElement>;
};

const styles = cssMap({
	wrapper: {
		flex: 1,
	},
});

export const AudioBriefingPopupListenPanel = ({ audioRef }: AudioBriefingPopupListenPanelProps) => {
	const [{ isPlaying, isLoading, hasFetched }, { fetchBriefing }] = useAudioBriefing();

	return (
		<AIEventsInstrumentationProvider config={aiAnalyticsConfig}>
			<Box paddingBlock="space.100" xcss={styles.wrapper} testId="listen-panel-controls">
				<Stack space="space.150" alignInline="center">
					<Inline space="space.200" alignBlock="center">
						<SkipBackButton audioRef={audioRef} isDisabled={isLoading} />
						<PlayPauseButton
							audioRef={audioRef}
							isPlaying={isPlaying}
							isLoading={isLoading}
							hasFetched={hasFetched}
							fetchContent={fetchBriefing}
						/>
						<SkipForwardButton audioRef={audioRef} isDisabled={isLoading} />
					</Inline>

					<AudioTimeIndicator audioRef={audioRef} isPlaying={isPlaying} />
				</Stack>
			</Box>
		</AIEventsInstrumentationProvider>
	);
};
